module.exports = __webpack_public_path__ + "static/media/video-icon4.3a2a95d3.svg";